<template>
  <div class="dashboard-team">
    <router-view></router-view>
  </div>
</template>

<script>
import TeamMemberList from './TeamMemberList.vue';
import MemberDetail from './MemberDetail.vue';

export default {
  children: [
    {
      path: '',
      name: 'team-member-list',
      component: TeamMemberList
    },
    {
      path: ':id',
      name: 'member-detail',
      component: MemberDetail,
      // Ensure that `id` is always passed as a number
      props(route) {
        const props = { ...route.params };
        props.id = +props.id;
        return props
      },
    }
  ]
}
</script>



// WEBPACK FOOTER //
// src/components/pages/dashboard/team/Team.vue